module.exports = __webpack_public_path__ + "img/astore.7a3041cf.svg";